import { call, put, takeLatest } from 'redux-saga/effects'
import {
  USER_FETCH_REQUESTED,
  USER_FETCH_SUCCEEDED,
  USER_FETCH_FAILED,
  HIDE_LOADER,
  USER_ACCESS_CHECK_SUCCEEDED,
  USER_ACCESS_CHECK_FAILED,
} from '../actionTypes'
import { getExtendedUser } from '../../services/userService'
import { redirectWhenNotAllowed } from '../../utils/userManager'

function* fetchUser(action: any) {
  try {
    const user = yield call(getExtendedUser, action.payload.accessToken)
    yield put({ type: HIDE_LOADER })
    yield put({ type: USER_FETCH_SUCCEEDED, payload: { user: user } })

    if (window.setIdentity) {
      window.setIdentity(user)
    }

    const accessAuthorizzed = yield call(redirectWhenNotAllowed, user)
    if (accessAuthorizzed) {
      yield put({ type: USER_ACCESS_CHECK_SUCCEEDED })
    } else {
      yield put({ type: USER_ACCESS_CHECK_FAILED })
    }
  } catch (error) {
    yield put({ type: USER_FETCH_FAILED, payload: { message: error.message } })
  }
}

function* extendedUserSaga() {
  yield takeLatest(USER_FETCH_REQUESTED, fetchUser)
}

export default extendedUserSaga
